/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_reinsurances_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Kontaktujte nás`
};

const da_reinsurances_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Kontakt os`
};

const de_reinsurances_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Kontaktieren Sie uns`
};

const en_reinsurances_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Contact us`
};

const es_reinsurances_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Contáctanos`
};

const fr_reinsurances_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Contactez nous`
};

const hu_reinsurances_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Lépj velünk kapcsolatba`
};

const it_reinsurances_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Contattaci`
};

const nl_reinsurances_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Neem contact op`
};

const pl_reinsurances_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Skontaktuj się z nami`
};

const pt_reinsurances_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Contacte-nos`
};

const sv_reinsurances_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Kontakta oss`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const reinsurances_contact_us = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.reinsurances_contact_us(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("reinsurances_contact_us", locale)
	if (locale === "cs") return cs_reinsurances_contact_us(inputs)
	if (locale === "da") return da_reinsurances_contact_us(inputs)
	if (locale === "de") return de_reinsurances_contact_us(inputs)
	if (locale === "en") return en_reinsurances_contact_us(inputs)
	if (locale === "es") return es_reinsurances_contact_us(inputs)
	if (locale === "fr") return fr_reinsurances_contact_us(inputs)
	if (locale === "hu") return hu_reinsurances_contact_us(inputs)
	if (locale === "it") return it_reinsurances_contact_us(inputs)
	if (locale === "nl") return nl_reinsurances_contact_us(inputs)
	if (locale === "pl") return pl_reinsurances_contact_us(inputs)
	if (locale === "pt") return pt_reinsurances_contact_us(inputs)
	return sv_reinsurances_contact_us(inputs)
};
export { reinsurances_contact_us as "reinsurances.contact_us" }